import _ from "lodash";
import Cookies from "js-cookie";
import $ from "jquery";
import { gsap } from "gsap";
//import {SplitText} from "gsap/SplitText";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {ScrollSmoother} from "gsap/ScrollSmoother";
import {ScrollToPlugin} from "gsap/ScrollToPlugin";
import {CSSRulePlugin} from 'gsap/CSSRulePlugin'

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, CSSRulePlugin, ScrollToPlugin);


class ThemeMain {
    private static saveScrollPositionToCookies(progress: number) {
        Cookies.set("scroll", progress, {
            path: location.pathname
        });
    }
    private debouncedSaveScrollPositionToCookies = _.debounce(ThemeMain.saveScrollPositionToCookies, 50, {
        maxWait: 200
    });
    private scrollProgress = Cookies.get('scroll');
    public smoother = null;
    public iOS() {
        return [
                'iPad Simulator',
                'iPhone Simulator',
                'iPod Simulator',
                'iPad',
                'iPhone',
                'iPod'
                // @ts-ignore
            ].includes(navigator.platform)
            // iPad on iOS 13 detection
            // @ts-ignore
            || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    }
    private onBeforeLoaded = [];
    private onAfterLoaded = [];

    public on(event: 'loaded' | 'load', callback: Function) {
        if(event === 'loaded') {
            this.onAfterLoaded.push(callback);
        }else if(event === 'load') {
            this.onBeforeLoaded.push(callback);
        }
    }

    public init() {
        let ios = this.iOS();
      //  ios = window.innerWidth < 768;

        if(this.onBeforeLoaded != null && this.onBeforeLoaded.length > 0) {
            this.onBeforeLoaded.forEach(callback => {
                try {
                    callback();
                }catch (e) {
                    console.error(e);
                }
            })

        }


    }

    public loaded() {
        $('.app').addClass('loaded');
        if(this.onAfterLoaded != null && this.onAfterLoaded.length > 0) {
            this.onAfterLoaded.forEach(callback => {
                try {
                    callback();
                }catch (e) {
                    console.error(e);
                }
            })
        }
    }
}

const theme = new ThemeMain();

document.addEventListener("DOMContentLoaded", function () {
    theme.init();
})

window.addEventListener('load', function () {
    theme.loaded();
});


export default theme;
export { gsap };
export { $ };
export { _ };
export { ScrollTrigger };
export { CSSRulePlugin };
export { ScrollToPlugin };